import { globalPresence, regionSummaries } from "@/data/globalPresence";

/**
 * Region pills: ALL + every region that actually has countries (counts computed from the dataset).
 * Horizontally scrollable on phones.
 */
export default function RegionFilter({ region, onChange, tone = "dark" }) {
  const summaries = regionSummaries();
  const total = globalPresence.filter((p) => p.active).length;
  const items = [{ id: "all", label: "All", count: total }, ...summaries];
  return (
    <div role="group" aria-label="Filter the map by region" className="gp-scroll -mx-1 flex snap-x gap-2 overflow-x-auto px-1 py-0.5">
      {items.map((r) => {
        const on = region === r.id;
        return (
          <button
            key={r.id}
            type="button"
            aria-pressed={on}
            onClick={() => onChange(r.id)}
            data-testid={`gp-region-${r.id}`}
            className={`inline-flex h-9 shrink-0 snap-start items-center gap-2 rounded-full border px-4 text-[11px] font-semibold uppercase tracking-[0.14em] transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#6EA2FF] ${
              on
                ? "border-[#1769FF] bg-[#1769FF] text-white shadow-[0_8px_22px_-10px_rgba(23,105,255,0.95)]"
                : tone === "dark"
                  ? "border-white/15 bg-white/[0.03] text-white/70 hover:border-white/35 hover:bg-white/10 hover:text-white"
                  : "border-[#D5DEEE] bg-white text-[#3B4A63] hover:border-[#1769FF] hover:text-[#1769FF]"
            }`}
          >
            {r.label}
            <span className={`text-[10px] tabular-nums ${on ? "text-white/80" : "opacity-60"}`}>{r.count}</span>
          </button>
        );
      })}
    </div>
  );
}
